import {NgModule} from "@angular/core";
import {NouisliderModule} from "ng2-nouislider";
import {CommonComponentsModule} from "../../common-components/common-components.module";
import {CheckboxComponent} from "./components/search-filter/checkbox/checkbox.component";
import {SearchMessageComponent} from "./components/search-message/search-message.component";
import {SearchFilterComponent} from "./components/search-filter/search-filter.component";
import {CharitySearchComponent} from "./charity-search.component";
import {ResultItemComponent} from "./components/search-results/result-item/result-item.component";
import {SearchResultsComponent} from "./components/search-results/search-results.component";

@NgModule({
    declarations: [
        CheckboxComponent,
        SearchMessageComponent,
        SearchFilterComponent,
        CharitySearchComponent,
        ResultItemComponent,
        SearchResultsComponent
    ],
    exports: [CharitySearchComponent],
    imports: [
        CommonComponentsModule,
        NouisliderModule
    ]
})
export class CharitySearchModule { }
